import React from 'react';
import { StyledDiv, StyledIcon } from 'components/ItemEmptyState/styles';
import { AssuranceIcon } from 'images';
import { ShortBody } from 'components/Typography';

const ItemEmptyState = (props: { label: string }) => {
  return (
    <StyledDiv>
      <StyledIcon src={AssuranceIcon['emptyBox']} alt="item-icon" />
      <ShortBody weight={'300'} color={'#9797AF'}>
        {props.label}
      </ShortBody>
    </StyledDiv>
  );
};

export default ItemEmptyState;
